import { AlertCircle } from 'lucide-react'
import { Button } from './Button'
import { cn } from '@/lib/utils'

interface ErrorDisplayProps {
  message: string
  onRetry?: () => void
  className?: string
}

function ErrorDisplay({ message, onRetry, className }: ErrorDisplayProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 text-center',
        className
      )}
      role="alert"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
        <AlertCircle className="h-6 w-6 text-destructive" aria-hidden="true" />
      </div>
      <p className="mt-4 text-sm text-muted-foreground max-w-sm">{message}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} className="mt-4">
          Try again
        </Button>
      )}
    </div>
  )
}

export { ErrorDisplay }
export type { ErrorDisplayProps }
